module.exports = __webpack_public_path__ + "static/img/LG.b9866d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/LG.png
// module id = ZTUW
// module chunks = 34